import { render } from "./NoteMod.vue?vue&type=template&id=24e64ada"
import script from "./NoteMod.vue?vue&type=script&lang=js"
export * from "./NoteMod.vue?vue&type=script&lang=js"

import "./NoteMod.vue?vue&type=style&index=0&id=24e64ada&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__